import { useEffect, useState } from "react"
import { deleteSurfacado, getSurfacadoDetails } from "../../../api"
import { mountApiUrl } from "../../../api/utils"
import config from "../../../environments/generated.config"
import { useBasket, useLoading, getHasBasketContent } from "../../../providers"
import { Layout } from "./Layout"

export const Surfacado = ({ item }) => {
  const [collapse, setCollapse] = useState(false)

  const [details, setDetails] = useState([])

  const { basketReload } = useBasket()
  const { setLoading } = useLoading()

  const editUrl = mountApiUrl(config.urls.home, config.urls.edit, {
    order_type: "surfacado",
    product_id: item.produto,
    order_os: item.OS,
  })

  const [editRoute] = useState(editUrl)

  const getDetails = async () => {
    try {
      setLoading(true)
      const data = await getSurfacadoDetails(item.produto, item.OS)
      data.SUCCESS ? setDetails(data.RESULT[0]) : setCollapse(false)
      setLoading(false)
    } catch (error) {
      setCollapse(false)
      setLoading(false)
    }
  }

  const toggleCollapse = () => setCollapse(!collapse)

  useEffect(() => {
    collapse && getDetails()
  }, [collapse])

  const handleDelete = async () => {
    await deleteSurfacado()
    await basketReload()
    await getHasBasketContent()
  }

  const layoutProps = {
    item,
    editRoute,
    collapse,
    details,
    handleDelete,
    toggleCollapse,
  }

  return <Layout {...layoutProps} />
}
